export default __webpack_public_path__ + "static/media/Tinos-Regular.83a9accf.ttf";